<script lang="ts">
	import type { Device } from 'src/types/Device';
	import RelayPriorityView from 'src/components/Sidepanel/DeviceViews/Relay/RelayPriorityView.svelte';
	import SidepanelMainViewHost from 'src/components/Sidepanel/SidepanelMainViewHost.svelte';

	export let device: Device;
</script>

{#if device.category === 'roller'}
	<SidepanelMainViewHost {device} />
{:else}
	<RelayPriorityView {device} />
{/if}
